import '../Styles/Papers.css'

export function Schedule() {
    return (
        <h2><a href="/schedule.pdf">Download the PDF</a></h2>
    )
}